import React, { useEffect, useState } from 'react';
import Header from '../../shared/components/Header';
import { useGetTravelDatesByNameQuery } from '../../features/traveldates/traveldatesFetch';
import FullPageLoader from '../../shared/components/Loader';
import { Title, Body } from '@vds/typography';
import styled from 'styled-components';
import { DateRange } from "react-date-range";
import { TextLink } from "@vds/buttons";
import Footer from '../../shared/components/Footer';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { isDesktop, isNative, isMdot, unauth, nsaUnauthToAuthFlowEnableFFlag, SessionIdGlobal, sessionIdMatchFixFFlag } from '../../shared/utils/globalConfig';
import { saveSelectedDates, setRecurringPlanSelected, clearFailedCartData, setDevicesPlansAPIFetch, setConfirmationPage,setUnauthToAuth, saveSelectedDestinations } from '../../features/selectedData/selectedDataReducer';
import { savePersistantDates, clearConfirmedPlanData, savePersistantDestinations } from '../../features/selectedData/persistantDataReducer';
import { formatDate,formatDateString } from '../../shared/utils/globalUtils';
import { getDestList } from '../../shared/utils/globalUtils';
import ErrorPage from '../../shared/components/ErrorPage';
import {dispatchPageView, dispatchVzdlEvent } from '../../shared/utils/tagging'
import Cookies from 'js-cookie';
const StyledTextLink = styled(TextLink)`
font-family: Verizon-NHG-eTX;
`

const TravelDatesPageMain = styled.div`
`
const TravelDatesPage = styled.div`
height: ${isDesktop ? '65vh' : isNative ? '82vh' : isMdot ? '69vh' : ''}; ;
overflow-y: auto;
scrollbar-width: thin;
`
const Padding = styled.div`
padding-top: ${props => props.pt || 8}px;
`
// const StyledCalendarDiv = styled.div`
// height: 320px;
// .rdrCalendarWrapper {
//     border: 1px solid black;
//     border-radius: 4px;
// }
// .rdrDayNumber{
//     font-size:12px;
// }
// .rdrDateDisplayWrapper {
//     display: none;
// }

// .rdrStartEdge {
//   background-color: #000000
// }
// .rdrEndEdge{
//   background-color: #ee0000 
// }

// .rdrInRange{
//   background-color: #d9d9d9
// }
// .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span {
//     color: #000000;
// }
// .rdrDayToday .rdrDayNumber span:after {
// width: 0px;
// }
// .rdrMonth {
//     @media screen and (min-width: 373px) and (max-width: 384px){
//         width: 20rem !important; 
//       }
//     @media screen and (min-width: 361px) and (max-width: 372px){
//         width: 19rem !important; 
//       }
//     @media screen and (min-width: 351px) and (max-width: 360px){
//         width: 18.5rem !important; 
//     }
//     @media screen and (min-width: 341px) and (max-width: 350px){
//         width: 17.5rem !important; 
//     }
//     @media screen and (min-width: 331px) and (max-width: 340px){
//         width: 17rem !important; 
//     }
//     @media screen and (min-width: 320px) and (max-width: 330px){
//         width: 16.5rem !important; 
//     }
// }
// .rdrDayToday .rdrDayNumber span{
//     font-weight: 300;
// }
// .rdrDayPassive .rdrDayNumber {
//     display: none;
// }
// .rdrDayPassive {
//     background-color: transparent;
//     }
// `;

const StyledCalendarDiv = styled.div`
.rdrWeekDay {
color: #000;
}
.rdrNextPrevButton {
    background-color: transparent;
    height:40px;
    width:40px;    
    border-radius: 50%;
}
.rdrNextPrevButton:focus {
    outline: dashed 1px;
}
.rdrPprevButton {
    background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHJvbGU9ImltZyIgYXJpYS1oaWRkZW49ImZhbHNlIiBhcmlhLWxhYmVsPSJsZWZ0LWNhcmV0IGljb24iIGFsdC10ZXh0PSJsZWZ0LWNhcmV0IGljb24iIHZpZXdCb3g9IjAgMCAyMS42IDIxLjYiIGZpbGw9IiMwMDAiIGNsYXNzPSJTdHlsZWRTVkctVkRTX19zYy0zemxhMjQtMCBnQlNUb2EiPjxwb2x5Z29uIHBvaW50cz0iMTQuODkgMTkuOCA1Ljg5IDEwLjc5OSAxNC44OSAxLjggMTUuNzEgMi42MTkgNy41MyAxMC43OTkgMTUuNzEgMTguOTgxIDE0Ljg5IDE5LjgiPjwvcG9seWdvbj48L3N2Zz4=");
    background-repeat: no-repeat no-repeat;
    background-position: center center;
    background-size: 16px 16px;
}
.rdrNextButton {
    background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHJvbGU9ImltZyIgYXJpYS1oaWRkZW49ImZhbHNlIiBhcmlhLWxhYmVsPSJyaWdodC1jYXJldCBpY29uIiBhbHQtdGV4dD0icmlnaHQtY2FyZXQgaWNvbiIgdmlld0JveD0iMCAwIDIxLjYgMjEuNiIgZmlsbD0iIzAwMDAwMCIgY2xhc3M9IlN0eWxlZFNWRy1WRFNfX3NjLTN6bGEyNC0wIGdCU1RvYSI+PHBvbHlnb24gcG9pbnRzPSI2LjcxIDE5LjggNS44OSAxOC45ODEgMTQuMDcgMTAuNzk5IDUuODkgMi42MTkgNi43MSAxLjggMTUuNzEgMTAuNzk5IDYuNzEgMTkuOCI+PC9wb2x5Z29uPjwvc3ZnPg==");
    background-repeat: no-repeat no-repeat;
    background-position: center center;
    background-size: 16px 16px;
}
.rdrNextPrevButton:hover {
    box-shadow: 0 0 0 0.0625rem rgba(111, 113, 113, 0.06);
    background-color: rgba(111, 113, 113, 0.06);
}
.rdrNextPrevButton i {
    border:initial;
}
.rdrCalendarWrapper {
    border: 1px solid black;
    border-radius: 4px;
    font-family: Verizon-NHG-eTX
}
.rdrDayNumber{
    font-size:12px;
}
.rdrDateDisplayWrapper {
    display: none;
}

.rdrStartEdge {
  background-color: #d9d9d9;
  top: 2px;
  bottom: 2px;
  left: 7px;
  border-top-left-radius: 50%;
  border-bottom-left-radius: 50%;  
}
.rdrEndEdge {
  background-color: #d9d9d9;
  top: 2px;
  bottom: 2px;
  right: 7px;
  border-top-right-radius: 50%;
  border-bottom-right-radius: 50%;  
}

.rdrInRange {
  background-color: #d9d9d9;
  top: 2px;
  bottom: 2px;
}
 .rdrStartEdge ~ .rdrDayNumber {
  background-color: #000000;
  top: 2px;
  bottom: 2px;
  right: 7px;
  left: 7px;
  border-radius: 50%;   
}
  .rdrEndEdge ~ .rdrDayNumber {
  background-color: #ee0000;
  border-radius: 50%; 
  top: 2px;
  bottom: 2px;
  right: 7px;
  left: 7px; 
}
.rdrDayStartPreview{
  border-top-left-radius: 50%;
  border-bottom-left-radius: 50%;
  top: 3px;
  bottom: 3px;
  left: 8px;
}
.rdrDayEndPreview{
  border-top-right-radius: 50%;
  border-bottom-right-radius: 50%;
  top: 3px;
  bottom: 3px;
  right: 8px;
}

.rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span {
    color: #000000;
}
.rdrDayToday .rdrDayNumber span:after {
width: 0px;
}
.rdrMonth {
    @media screen and (min-width: 373px) and (max-width: 384px){
        width: 20rem !important; 
      }
    @media screen and (min-width: 361px) and (max-width: 372px){
        width: 19rem !important; 
      }
    @media screen and (min-width: 351px) and (max-width: 360px){
        width: 18.5rem !important; 
    }
    @media screen and (min-width: 341px) and (max-width: 350px){
        width: 17.5rem !important; 
    }
    @media screen and (min-width: 331px) and (max-width: 340px){
        width: 17rem !important; 
    }
    @media screen and (min-width: 320px) and (max-width: 330px){
        width: 16.5rem !important; 
    }
}
.rdrDayToday .rdrDayNumber span{
    font-weight: 300;
}
.rdrDayPassive .rdrDayNumber {
    display: none;
}
.rdrDayPassive {
    background-color: transparent;
    }
`;

const updateDayCellAriaLabels = () => {
    setTimeout(()=>{
        try{
            const monthAndYear = document.querySelector('span[class="rdrMonthAndYearPickers"]').textContent.split(" ");
            const buttons = document.querySelectorAll('button[class^="rdrDay"]');
            const month = monthAndYear[0];
            const year = monthAndYear[1];
            Array.from(buttons).forEach(button => {
                button.setAttribute("aria-label",`${month} ${button.innerText}, ${year}`);
            })
        }catch{}
    },200)

}

const setMonthChangeOnClick = (setEventListenerAriaLabel) => {
    try{
        const prevButton = document.querySelector('button[class="rdrNextPrevButton rdrPprevButton"]');
        const nextButton = document.querySelector('button[class="rdrNextPrevButton rdrNextButton"]');
        prevButton.addEventListener("click", updateDayCellAriaLabels);
        nextButton.addEventListener("click", updateDayCellAriaLabels);
        prevButton.addEventListener("keydown", updateDayCellAriaLabels);
        nextButton.addEventListener("keydown", updateDayCellAriaLabels);
        if(prevButton && nextButton) {
            updateDayCellAriaLabels()
            setEventListenerAriaLabel(true)
        }
    }catch{}
}

export default function TravelDates() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { selectedDestinations,selectedDates } = useSelector(state => state?.persistantReducer);
    const { retainDatesAndDestinations, sessionIdVar } = useSelector(state => state?.selectedReducer);
    const [traveldatesData, setTravelDatesDateData] = useState();
    const [disableNextButton, setDisablenextButton] = useState(true);
    const [maxDate, setMaxDate] = useState(new Date());
    const [focusedRanges, setFocusedRanges] = useState();
    const [isEventListenerSet,setEventListenerAriaLabel] = useState(false);

    const getPayload = () => {
        let payload = {
            'destinations': getDestList(selectedDestinations, 'key'),
            'unAuthflow': unauth ? true : false
        }
        return payload;
    }
    let isSesIdNotMatched =  false;
    if(sessionIdMatchFixFFlag && !unauth){
        isSesIdNotMatched = (sessionIdVar === SessionIdGlobal)? false : true;}

    let { data, error, isSuccess, isLoading } = useGetTravelDatesByNameQuery(getPayload(), { skip: (selectedDestinations.length === 0 || isSesIdNotMatched) });

    // to set startDate when page loads
    const [calendarRange, setCalendarRange] = useState([{
        startDate: null,
        endDate: new Date(""),
        key: 'selection'
    }]);
    useEffect(() => {
        if(retainDatesAndDestinations){
        setCalendarRange([{
            startDate: formatDateString(selectedDates?.travelStartDate),
            endDate: formatDateString(selectedDates?.travelEndDate),
            key: 'selection'
        }]);
        setDisablenextButton(false);
    }
    }, [selectedDates, data])

    useEffect(()=>{
        if(!isEventListenerSet) setMonthChangeOnClick(setEventListenerAriaLabel)
    })
    useEffect(() => {
        if (sessionIdMatchFixFFlag && isSesIdNotMatched && !unauth) {
            dispatch(saveSelectedDestinations([]));
            dispatch(savePersistantDestinations([]));
            navigate('/', { replace: true })
        }

    }, [])

    //Tagging
    useEffect(() => {
        dispatchVzdlEvent("event117");
        dispatchPageView('ITP_Traveldates','pick dates','#travel_dates');

    },[])

    useEffect(() => {
        if (selectedDestinations.length === 0 ) {
            navigate('/', { replace: true })
        }

    }, [selectedDestinations])

    useEffect(() => {
        setTravelDatesDateData(data?.body?.data?.travelDates);
        setMaxDate(new Date(data?.body?.data?.travelDates?.travelDatesLimit?.max))
    }, [data])

    // to reset dates
    const onResetDateLinkClick = () => {
        setMaxDate(new Date(traveldatesData?.travelDatesLimit?.max));
        setCalendarRange([
            {
                startDate: null,
                endDate: new Date(""),
                key: 'selection'
            }
        ])
        setFocusedRanges([0, 0]);
        setDisablenextButton(true);
    }
    // event trigger when you do calendar change
    const handleCalendarChange = (item) => {
        setFocusedRanges();
        let selecteddate = item.selection.startDate;

        let selecteddatetime = new Date(selecteddate).getTime();
        let maxdatetime = new Date(traveldatesData?.travelDatesLimit?.max).getTime();

        if (selecteddatetime > maxdatetime) {
            onResetDateLinkClick();
        } else if (selecteddate) {
            const maxdate = new Date(selecteddate);
            maxdate.setDate(selecteddate.getDate() + parseInt(traveldatesData?.travelDatesLimit?.maxDays));
            setMaxDate(maxdate);
            setCalendarRange([item.selection]);
            if (item.selection?.startDate?.toLocaleDateString() != item.selection?.endDate?.toLocaleDateString()) {
                setDisablenextButton(false);
            }
            else {
                setDisablenextButton(true);
            }
        }

    }

    const nextButtonClick = () => {
        if(!unauth && nsaUnauthToAuthFlowEnableFFlag){
        Cookies.remove('NsaUnAuthSessionId');
        dispatch(setUnauthToAuth(false))
    }
    
        const { startDate, endDate } = calendarRange[0];
        let payload = {
            "travelStartDate": formatDate(startDate),
            "travelEndDate": formatDate(endDate)
        }
       

        dispatch(saveSelectedDates(payload));
        dispatch(savePersistantDates(payload));
        dispatch(clearConfirmedPlanData());
        dispatch(clearFailedCartData());
        dispatch(setRecurringPlanSelected(false));
        dispatch(setConfirmationPage(false));
        dispatch(setDevicesPlansAPIFetch(true));
        navigate(traveldatesData?.ctaList[0]?.ctaUrl,{state:"/itptraveldates"})
    }
   
    const getSelectedDaysCount = () => {
        const { startDate, endDate } = calendarRange[0];
        if (startDate && endDate) {
            let startDateValue = typeof (startDate) === 'string' ? new Date(startDate) : startDate;
            let endDateVaue = typeof (endDate) === 'string' ? new Date(endDate) : endDate;
            const timeDiff = Math.abs(endDateVaue.getTime() - startDateValue.getTime());
            const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;
            return diffDays;
        } else {
            return 0;
        }
    }


    return (
        <TravelDatesPageMain id="travel_dates">
            {(isSuccess && traveldatesData) ?
                (<>
                    <TravelDatesPage>
                        <Header pageTitle={traveldatesData?.pageTitle} progressData={traveldatesData?.progressBar}></Header>
                        <Title size="large">{traveldatesData?.heading}</Title>
                        <Padding />
                        <Body size="large">{traveldatesData?.topHeading}</Body>
                        <Padding pt={16} />
                        <StyledCalendarDiv>
                            <DateRange
                                editableDateInputs={true}
                                showMonthAndYearPickers={false}
                                retainEndDateOnFirstSelection={false}
                                fixedHeight={true}
                                focusedRange={focusedRanges}
                                onChange={(item) => handleCalendarChange(item)}
                                moveRangeOnFirstSelection={false}
                                ranges={calendarRange}
                                minDate={new Date(traveldatesData?.travelDatesLimit?.min)}
                                maxDate={maxDate}
                                prevButton={false}
                                ariaLabels={{
                                    dateInput: {
                                      selection1: { startDate: "start date input of departure", endDate: "end date input of departure" }
                                    },
                                    monthPicker: "month picker",
                                    yearPicker: "year picker",
                                    prevButton: "previous month button",
                                    nextButton: "next month button",
                                  }}
                            />
                        </StyledCalendarDiv>
                        <Padding pt={24} />
                        <StyledTextLink onClick={onResetDateLinkClick}>{traveldatesData?.belowHeading}</StyledTextLink>
                        <Padding pt={24} />
                    </TravelDatesPage>
                    <Footer ariaLabel={`no of days:${getSelectedDaysCount()}|next`} ctaLabel={traveldatesData?.ctaList[0]?.ctaLabel} handleButtonChange={() => nextButtonClick()} disabled={disableNextButton}></Footer>
                </>
                )
                : (error && <ErrorPage errorDetails={error?.data} />)
            }
            {isLoading && <FullPageLoader />}

        </TravelDatesPageMain>
    )

}